import { ACCENT, INK, illustrationA11y, lineStyle } from './static-art';

export function PosDonationIllustration(props: { className?: string; label?: string; ink?: string }) {
	const ink = props.ink ?? INK;
	const line = lineStyle(ink, 0.746963);
	return (
		<svg
			width="255"
			height="318"
			viewBox="0 0 255 318"
			fill="none"
			className={props.className}
			{...illustrationA11y(props.label)}
		>
			<path
				d="M40.9728 213.851C36.6031 217.499 31.7603 222.742 33.7522 228.075C34.3846 229.771 35.6495 231.143 36.8894 232.46C45.467 241.573 54.4007 250.355 63.6581 258.778C66.9397 261.764 70.5326 264.834 74.9223 265.461C82.1354 266.494 88.3527 260.738 93.3797 255.464C128.629 218.475 150.129 197.029 187.856 162.569"
				{...line}
			/>
			<path
				d="M187.895 162.472C196.211 150.411 211.397 147.107 224.815 141.223C226.414 140.521 228.291 139.216 227.868 137.521C227.606 136.477 226.556 135.867 225.602 135.372C213.591 129.145 201.582 122.917 189.571 116.688C186.887 115.296 184.165 113.892 181.359 112.759"
				{...line}
			/>
			<path
				d="M41.0479 213.813C77.8134 179.58 99.0495 159.92 135.815 125.687C142.045 119.885 159.312 100.106 181.36 112.759"
				{...line}
			/>
			<path
				d="M227.445 136.557C233.234 140.882 236.147 148.769 236.04 155.995C235.851 168.86 230.321 181.564 221.033 190.47C211.746 199.376 198.821 204.368 185.961 204.02"
				{...line}
			/>
			<path
				d="M33.2545 224.609C31.2949 227.811 31.5016 232.288 33.2047 235.632C34.9078 238.978 37.679 241.633 40.4004 244.22C52.2199 255.456 64.0418 266.696 75.8612 277.933C79.8127 281.687 84.4214 285.427 89.8718 285.387C101.898 285.3 107.094 277.564 111.033 273.112"
				{...line}
			/>
			<path d="M111.104 273.067C119.582 266.282 171.1 217.752 185.934 204" {...line} />
			<path
				d="M114.356 258.78C114.74 254.209 112.895 245.099 121.923 235.049C138.466 216.634 142.726 212.275 161.602 196.257C162.874 195.177 164.181 194.086 165.72 193.441C167.505 192.694 169.482 192.592 171.409 192.43C177.789 191.89 184.073 190.565 190.338 189.243"
				{...line}
			/>
			<path d="M133.591 128.54C152.305 139.986 171.449 151.932 188.771 161.008" {...line} />
			<path
				d="M47.9427 213.428L128.363 138.418C130.002 136.894 132.427 136.578 134.404 137.626L171.799 160.662C174.954 162.338 175.551 166.608 172.977 169.085L88.3235 250.758C86.3416 252.666 83.2242 252.723 81.1751 250.888L48.0124 221.189C45.7093 219.127 45.6769 215.532 47.9402 213.428H47.9427Z"
				{...line}
			/>
			<path
				d="M61.604 78.6725C52.1872 69.8533 59.2261 54.4186 72.2656 55.5241C77.9102 56.0021 83.5871 61.5023 84.1224 67.1717C85.3076 79.7207 70.8862 87.3646 61.604 78.6725Z"
				fill={ACCENT}
			/>
			<path
				d="M71.337 61.6035C71.337 61.6035 64.2607 63.1248 65.5405 69.8724C66.7108 76.0498 72.7438 76.2066 75.8934 73.7193"
				stroke={ink}
				strokeWidth="0.99595"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M62.9492 69.6398L71.4073 66.8213"
				stroke={ink}
				strokeWidth="0.99595"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M63.8623 73.0295L72.3229 70.2109"
				stroke={ink}
				strokeWidth="0.99595"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M85.2257 122.609C68.9045 107.324 81.1024 80.5773 103.703 82.492C113.486 83.3211 123.323 92.8524 124.252 102.677C126.306 124.427 101.313 137.673 85.2257 122.609Z"
				fill={ACCENT}
			/>
			<path
				d="M108.862 200.113C98.5344 203.447 86.5083 201.433 77.2708 191.882C56.4007 170.302 74.532 135.247 104.709 139.315C117.771 141.076 130.33 154.511 130.923 167.747C131.167 173.175 130.183 178.15 128.291 182.52"
				fill={ACCENT}
			/>
			<path
				d="M102.811 92.3613C102.811 92.3613 89.9737 95.1201 92.2967 107.36C94.4206 118.565 105.361 118.849 111.078 114.339"
				stroke={ink}
				strokeWidth="0.99595"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M87.5928 106.935L102.938 101.821"
				stroke={ink}
				strokeWidth="0.99595"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M89.2549 113.087L104.6 107.971"
				stroke={ink}
				strokeWidth="0.99595"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M108.832 155.177C108.832 155.177 92.3419 150.416 87.4468 165.953C82.9651 180.17 95.392 187.264 104.764 185.603"
				stroke={ink}
				strokeWidth="0.99595"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M82.293 162.555L103.131 166.15"
				stroke={ink}
				strokeWidth="0.99595"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M80.4033 170.666L101.241 174.261"
				stroke={ink}
				strokeWidth="0.99595"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M99.9639 208.943L136.757 174.884" {...line} />
		</svg>
	);
}
